import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/homeData';

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              影视资讯
            </h2>
            <p className="text-foreground-500 text-sm">行业动态、观影指南、深度解析</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden hover:bg-background-50/80 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}